import PropTypes from 'prop-types'
import React from 'react'
import {
  Datagrid,
  DateField,
  FunctionField,
  TextField,
  WithRecord,
  useRefresh,
} from 'react-admin'
import { Box, Button, Typography } from '@mui/material'
import { LockOpen } from '@mui/icons-material'
import ViewQuoteButton from './ViewQuoteButton'
import { handleLeadLocking } from '../../Utils/RestUtils'

export default function TableLayout({ userId, showUnlockButton = false }) {
  const refresh = useRefresh()

  const unlockLead = async (leadId, method) => {
    await handleLeadLocking(method, leadId)
    refresh()
  }

  return (
    <>
      <Datagrid bulkActionButtons={false}>
        <FunctionField
          sortable={false}
          label="Created at"
          render={() => (
            <React.Fragment>
              <DateField source="dateCreated" locales="en-GB" />
              <br />
              <Typography component="span">@&nbsp;</Typography>
              <DateField source="dateCreated" showTime showDate={false} />
            </React.Fragment>
          )}
        />
        <TextField
          source="leadContact.vehicle.registration"
          sortable={false}
          label="Reg"
          sx={{ textTransform: 'uppercase' }}
        />
        <TextField
          source="leadContact.vehicle.make"
          sortable={false}
          label="Make"
          sx={{ textTransform: 'uppercase' }}
        />
        <TextField
          source="leadContact.vehicle.model"
          sortable={false}
          label="Model"
          sx={{ textTransform: 'uppercase' }}
        />
        <WithRecord
          render={(record) => {
            const inUseBy = record.inUse
              ? record.inUse.replace('/api/users/', '')
              : null
            return (
              <Box sx={{ display: 'flex', gap: 1 }}>
                <ViewQuoteButton />
                <Button
                  label=""
                  startIcon={<LockOpen sx={{ mr: '-10px' }} />}
                  size="small"
                  onClick={() => {
                    unlockLead(record.originId, 'unlock')
                  }}
                  sx={{
                    display:
                      inUseBy === userId && showUnlockButton ? 'block' : 'none',
                  }}
                />
              </Box>
            )
          }}
        />
      </Datagrid>
    </>
  )
}

TableLayout.propTypes = {
  userId: PropTypes.string,
  showUnlockButton: PropTypes.bool,
}
